import { cancelled, put, take } from 'redux-saga/effects'

export function* syncChannel(channel, options) {
  const { successActionCreator, failureActionCreator, transform, params } = options

  try {
    while (true) {
      const data = yield take(channel)
      // Before transform, which expects a snapshot: given an error it would
      // throw one of its own, and that is what failureActionCreator would
      // carry to the screen instead of what Firestore actually said.
      if (data instanceof Error) throw data
      const transformedData = transform ? transform(data, params) : data
      yield put(successActionCreator(transformedData))
    }
  } catch (err) {
    if (failureActionCreator) yield put(failureActionCreator(err))
  } finally {
    if (yield cancelled()) channel.close()
  }
}
